// Services
import { RegistrationsService } from 'ClientManagementApp/ts/services/registrations.service';
// Types, Enums, Constants
import { RegistrationStatus, REGISTRATION_STATUS_OPTIONS } from 'ClientManagementApp/ts/constants';
import * as i0 from "@angular/core";
import * as i1 from "ClientManagementApp/ts/services/registrations.service";
import * as i2 from "@angular/common";
function RegistrationStatusUpdateDropdownComponent_label_7_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 6);
    i0.ɵɵlistener("click", function RegistrationStatusUpdateDropdownComponent_label_7_Template_label_click_0_listener() { const option_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectRegistrationStatus(option_r2)); });
    i0.ɵɵelementStart(1, "input", 7);
    i0.ɵɵlistener("click", function RegistrationStatusUpdateDropdownComponent_label_7_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r1); $event.preventDefault(); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 8);
    i0.ɵɵelementStart(3, "span", 9)(4, "span", 3);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r2.selectedStatus.value === option_r2.value);
    i0.ɵɵadvance(3);
    i0.ɵɵclassMap(option_r2.pillClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r2.label);
} }
export class RegistrationStatusUpdateDropdownComponent {
    constructor(registrationsService) {
        this.registrationsService = registrationsService;
        this.status = RegistrationStatus.ACTIVE;
        this.isDropdownOpen = false;
        this.statusOptions = REGISTRATION_STATUS_OPTIONS;
        this.selectedStatus = this.statusOptions[0];
    }
    ngOnInit() {
        this.setSelectedStatus();
    }
    setSelectedStatus() {
        const matchingOption = this.statusOptions.find((option) => option.value.toLowerCase() === this.status.toLowerCase());
        if (matchingOption) {
            this.selectedStatus = matchingOption;
        }
    }
    selectRegistrationStatus(option) {
        const oldStatus = this.status;
        // Update status before request so UI automatically updates.
        // On error this change is reverted.
        this.status = option.value;
        this.setSelectedStatus();
        this.toggleDropdown();
        this.registrationsService.updateRegistrationStatus(parseInt(this.registrationId, 10), this.status).subscribe({
            error: () => {
                this.status = oldStatus;
                this.setSelectedStatus();
            },
        });
    }
    toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }
}
RegistrationStatusUpdateDropdownComponent.ɵfac = function RegistrationStatusUpdateDropdownComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RegistrationStatusUpdateDropdownComponent)(i0.ɵɵdirectiveInject(i1.RegistrationsService)); };
RegistrationStatusUpdateDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RegistrationStatusUpdateDropdownComponent, selectors: [["ycn-registration-status-update-dropdown"]], inputs: { status: "status", registrationId: "registrationId" }, standalone: false, decls: 8, vars: 10, consts: [[1, "dropdown"], [1, "dropdown-toggle", "btn", "btn-secondary", "width-full", 3, "click"], [1, "d-flex", "mr-auto"], [1, "pill"], [1, "dropdown-menu", "width-full"], ["class", "custom-control custom-checkbox custom-checkbox-style1 dropdown-item", "style", "cursor: pointer;", 3, "click", 4, "ngFor", "ngForOf"], [1, "custom-control", "custom-checkbox", "custom-checkbox-style1", "dropdown-item", 2, "cursor", "pointer", 3, "click"], ["type", "checkbox", "readonly", "", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"]], template: function RegistrationStatusUpdateDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵlistener("click", function RegistrationStatusUpdateDropdownComponent_Template_div_click_1_listener() { return ctx.toggleDropdown(); });
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3, " STATUS:\u00A0");
        i0.ɵɵelementStart(4, "span", 3);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵtemplate(7, RegistrationStatusUpdateDropdownComponent_label_7_Template, 6, 4, "label", 5);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵclassProp("show", ctx.isDropdownOpen);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("active", ctx.isDropdownOpen);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap(ctx.selectedStatus.pillClass);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(ctx.selectedStatus.label);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("show", ctx.isDropdownOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.statusOptions);
    } }, dependencies: [i2.NgForOf], encapsulation: 2 });
